<div class="m-search-tabs">
	<div class="m-search-tabs__bg-line"></div>
	<ul class="m-search-tabs__list" data-t-name="SearchTabs">
		<li
			class="m-search-tabs__tab"
			[ngClass]="{'m-search-tabs__tab--active' : resultTab.active}"
			(click)="tabClick(resultTab)"
			*ngFor="let resultTab of resultTabs"
		>
			<span [innerHTML]="getTabHeading(resultTab)"></span>
		</li>
	</ul>
</div>
